import { useParams } from "react-router-dom";
import { useMovimentacaoBuscar } from "../../../../../Services/Financeiro/Conta/MovimentacaoService";
import MovimentacaoForm, { IMovimentacaoFormProps } from "./MovimentacaoForm";
import TelaCarregamento from "../../../../Base/Carregamento/TelaCarregamento";

export interface IMovimentacaoEditarScreenProps extends IMovimentacaoFormProps {
    codigo?:number;
}

export default function MovimentacaoEditarScreen({
    codigo : codigoParam,
    ...rest
}:IMovimentacaoEditarScreenProps) {
    const { codigo : codigoRota } = useParams();
    const codigo = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");
    
    const {
        data,
        isLoading
    } = useMovimentacaoBuscar({
        codigo : codigo ?? 0,
        enabled : codigo !== undefined && !isNaN(codigo)
    });
    
    return <TelaCarregamento ativo={isLoading}>
        <MovimentacaoForm 
            {...rest}
            codigo={codigo}
            initialValues={{
                movimentacao : data ?? undefined
            }}
        />
    </TelaCarregamento>
}